import Handlebars from "handlebars";
import assetAttachmentTemplate from "./dealRoom/DealRoomAttachment.handlebars.js";

Handlebars.registerPartial('DealRoomAttachment', assetAttachmentTemplate);

const templateString=`<p>Hello there, </p> 
<p>&nbsp;</p> 
<p>I've set up a personalized Deal Room for you. You'll have access to all the relevant content and updates as we move forward.</p>  
<p>&nbsp;</p>
<p>Feel free to explore and reach out if you have any questions.</p>  
<p>&nbsp;</p>
<p>&nbsp;</p>
<div class="mceNonEditable widget" data-widget-id="assets.grid">
  {{> DealRoomAttachment}}
</div>

<p>&nbsp;</p>
<p>&nbsp;</p>
<p><p class="variable mceNonEditable" data-original-variable="{signature.description}">signature</p>
<p>&nbsp;</p>`

const template = Handlebars.compile(templateString);
export default template;